import { api, refreshApi } from './http'

let refreshTokenTimer = null

// Token 配置（与后端保持一致）
const TOKEN_EXPIRE_MINUTES = 15
const REFRESH_BUFFER_MINUTES = 5
const CHECK_INTERVAL_MS = 60 * 1000 // 每分钟检查一次

// 主动刷新 token
async function proactiveRefreshToken() {
  const token = localStorage.getItem('token')
  if (!token) return

  const timestamp = parseInt(localStorage.getItem('tokenTimestamp') || '0', 10)
  if (!timestamp) return

  const now = Date.now()
  const expireAt = timestamp + TOKEN_EXPIRE_MINUTES * 60 * 1000
  const remainMs = expireAt - now
  const bufferMs = REFRESH_BUFFER_MINUTES * 60 * 1000

  // 如果剩余时间大于缓冲时间，无需刷新
  if (remainMs > bufferMs) return

  // 如果已过期，不主动刷新（让401拦截器处理）
  if (remainMs <= 0) return

  console.log(`[Token] 剩余 ${Math.round(remainMs / 1000)}s，主动刷新中...`)

  try {
    const res = await refreshApi.post('/front/auth/refresh')
    const newToken = res.data.data.token
    localStorage.setItem('token', newToken)
    localStorage.setItem('tokenTimestamp', Date.now().toString())
    console.log('[Token] 主动刷新成功')
  } catch (error) {
    console.error('[Token] 主动刷新失败:', error)
  }
}

// 启动 token 自动刷新定时器
export function startTokenRefreshTimer() {
  stopTokenRefreshTimer()
  proactiveRefreshToken()
  refreshTokenTimer = setInterval(() => {
    proactiveRefreshToken()
  }, CHECK_INTERVAL_MS)
  console.log('[Token] 自动刷新定时器已启动')
}

// 停止 token 自动刷新定时器
export function stopTokenRefreshTimer() {
  if (refreshTokenTimer) {
    clearInterval(refreshTokenTimer)
    refreshTokenTimer = null
    console.log('[Token] 自动刷新定时器已停止')
  }
}

export function login(username, password, captchaId, captchaCode) {
  return api.post('/front/auth/login', { username, password, captcha_id: captchaId, captcha_code: captchaCode })
}

export function generateCaptcha() {
  return api.get('/front/auth/captcha')
}

export function getCaptcha() {
  return api.get('/front/auth/captcha')
}

export function refreshCaptcha(captchaId) {
  return api.post('/front/auth/captcha/refresh', { captcha_id: captchaId })
}

export function getGitHubLoginURL(redirect) {
  const base = `${api.defaults.baseURL}/front/auth/github`
  return redirect ? `${base}?redirect=${encodeURIComponent(redirect)}` : base
}

export function getGitHubUserInfo() {
  return api.get('/front/user/me')
}
